import React from 'react';
import back from './MemberCardBack.png';

export const MemberCardBack = () => (
  <div style={{ border: '1px solid #464646', borderRadius: '25px', padding: '15px' }}>
    <span><img src={back} alt="Member Card Back" className="img-responsive" /></span>
  </div>
);
